
import { useEffect, useRef } from 'react'

import { createPortal } from 'react-dom'
import styled from 'styled-components'

import { IconOptionsThrash } from 'assets/svg/sprite'
import { useHeaderLayout } from 'context/headerLayoutContext'
import screens from 'styles/screens'

interface ConversationOptionsDropdownProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  onDelete: () => void
  withoutBottomNavigation?: boolean
}

export const ConversationOptionsDropdown = ({
  isOpen,
  setIsOpen,
  onDelete,
  withoutBottomNavigation = false,
}: ConversationOptionsDropdownProps) => {
  const optionsRef = useRef<HTMLDivElement>(null)
  const { hideFooter } = useHeaderLayout()

  useEffect(() => {
    if (!isOpen) return

    const handlePointerDown = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node | null
      if (!target) return

      if (optionsRef.current?.contains(target)) return

      setIsOpen(false)
    }

    document.addEventListener('mousedown', handlePointerDown)
    document.addEventListener('touchstart', handlePointerDown)

    return () => {
      document.removeEventListener('mousedown', handlePointerDown)
      document.removeEventListener('touchstart', handlePointerDown)
    }
  }, [isOpen, setIsOpen])

  if (!isOpen) return null

  return createPortal(
    <>
      <BackgroundContainer onClick={() => setIsOpen(false)} />

      <OptionsDropdownWrapper
        ref={optionsRef}
        $withoutBottomNavigation={withoutBottomNavigation}
        $hideFooter={hideFooter}
      >
        <div className="post__options__dropdown__section">
          <div
            className="post__options__option"
            onClick={() => {
              setIsOpen(false)
              onDelete()
            }}
          >
            <IconOptionsThrash />
            <span>Delete Conversation</span>
          </div>
        </div>
      </OptionsDropdownWrapper>
    </>,
    document.body
  )
}

const BackgroundContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999998;
  background: transparent;
`

interface OptionsDropdownWrapperProps {
  $withoutBottomNavigation: boolean
  $hideFooter: boolean
}

const OptionsDropdownWrapper = styled.div<OptionsDropdownWrapperProps>`
  position: fixed;
  z-index: 999999;

  background: #fff;

  width: calc(100% - 3.2rem);
  max-width: 500px;

  height: auto;
  min-height: 0;
  max-height: calc(100dvh - 3.2rem);

  overflow-y: auto;

  padding: 3rem 0;

  border-radius: 2.5rem;

  box-shadow: 0 2rem 6rem rgba(17, 29, 41, 0.25);

  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;

  transform: translate(-50%, -50%);

  @media (max-width: ${screens.medium}) {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    max-width: none;

    transform: none;

    border-radius: 2.5rem 2.5rem 0 0;

    box-shadow: 0 -20px 40px rgba(17, 29, 41, 0.1);

    padding-bottom: 3rem;
  }
`
